import React from "react";
import { FormattedMessage } from "react-intl";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";
import Link from "../../Link/Link";
import cs from '../../../components/commonStyle.css';
import s from "./AdminDashboard.css";
import { NextIconSvg } from "../../Common/Assets/SvgIconComponent/CommonSvgIcon";
import messages from '../../../locale/jsonMessages';
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";

const DashboardCard = ({
    title,
    last24HoursCount,
    last30DaysCount,
    total,
    displayTotal,
    last7DaysCount,
    icon,
    management,
    type,
    customCount,
    isCustom,
    dates,
    iconColor,
    iconBgColor,
    privilegeId,
    validPrivilege,
    isAdminUser,
    isEarnings,
    currency
}) => {
    let Icon = icon

    let showManagementLink = isAdminUser ? isAdminUser : validPrivilege?.includes(privilegeId);
    let totalFilter = displayTotal !== undefined ? displayTotal : total
    return (
        <div className={s.dashboardCard} style={{ '--icon-color': iconColor, '--icon-background': iconBgColor }}>
            <div className={s.dashboardCardHeaderWrapper}>
                <div className={cx(s.dashboardCardHeaderTitleFlex, cs.spaceBottom1)}>
                    <span className={cx(cs.commonContentText, cs.greyText, cs.fontWeightMedium)}>{title}</span>
                    <div className={s.dashboardCardIconWrapper}>
                        <Icon />
                    </div>
                </div>
                {!isEarnings && <div className={cx(s.dashboardCardTotal, cs.commonTitleText, cs.fontWeightBold)}>{totalFilter}</div>}
                {isEarnings && <div className={cx(s.dashboardCardTotal, cs.commonTitleText, cs.fontWeightBold)}><CurrencyConverter amount={totalFilter} currency={currency} isDashboard={true} /></div>}
            </div>
            <div className={s.dashboardEaringsReportWrapper}>
                <div className={s.dashboardCardRow}>
                    <span><FormattedMessage  {...messages.last30daysUsers} /></span>
                    <span>{isEarnings ? <CurrencyConverter amount={last30DaysCount} currency={currency} isDashboard={true} /> : last30DaysCount}</span>
                </div>
                <div className={s.dashboardCardRow}>
                    <span><FormattedMessage  {...messages.last7Days} /></span>
                    <span>{isEarnings ? <CurrencyConverter amount={last7DaysCount} currency={currency} isDashboard={true} /> : last7DaysCount}</span>
                </div>
                <div className={s.dashboardCardRow}>
                    <span><FormattedMessage  {...messages.last24hoursListings} /></span>
                    <span>{isEarnings ? <CurrencyConverter amount={last24HoursCount} currency={currency} isDashboard={true} /> : last24HoursCount}</span>
                </div>
                {
                    isCustom && <div className={s.dashboardCardRow}>
                        <span>{dates}</span>
                        <span>{isEarnings ? <CurrencyConverter amount={customCount} currency={currency} isDashboard={true} /> : customCount}</span>
                    </div>
                }
                {showManagementLink && (
                    <div className={cx(s.dashboardCardLinkContainer, cs.spaceTop3)}>
                        <Link to={`/siteadmin/${type}/`} className={s.dashboardCardLink} >
                            <span>{management}</span><NextIconSvg className={'imageRotate'} />
                        </Link>
                    </div>
                )}
            </div>

        </div>
    );
};

export default withStyles(cs, s)(DashboardCard);
